var React = require('react');

function Skull (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M21.75,10.5a9.75,9.75,0,1,0-16.5,7.025V21a2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0,2.25,2.25,0,0,0,4.5,0V17.525A9.714,9.714,0,0,0,21.75,10.5Z","key":1}),React.createElement("circle",{"className":"a","cx":"7.5","cy":"10.5","r":"2.25","key":2}),React.createElement("circle",{"className":"a","cx":"16.5","cy":"10.5","r":"2.25","key":3}),React.createElement("line",{"className":"a","x1":"12","y1":"15","x2":"12","y2":"17.25","key":4})]);
}

Skull.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Skull;

Skull.default = Skull;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/skull.svg
// module id = 1084
// module chunks = 0